import {
  IDashboardBrokerFilterOption,
  IDashboardBrokerOptionListItem,
} from '@/bundles/Dashboards/types';

export const BROKER_ID_PREFIX = 'Contact/';

export function toBrokerOption (item: IDashboardBrokerOptionListItem): IDashboardBrokerFilterOption {
  return {
    value: `${BROKER_ID_PREFIX}${item.id}`,
    text: item.full_name,
    email: item.email,
    member: item.member,
  };
}
